import { render, staticRenderFns } from "./TransactionTable.component.vue?vue&type=template&id=2f6c8cfb&scoped=true"
import script from "./TransactionTable.component.vue?vue&type=script&lang=ts"
export * from "./TransactionTable.component.vue?vue&type=script&lang=ts"
import style0 from "./TransactionTable.component.vue?vue&type=style&index=0&id=2f6c8cfb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f6c8cfb",
  null
  
)

export default component.exports